import "./../css/style.scss";
import $ from 'jquery';

let winScroll = 0;
let didAnimate;
$(function () {
    winScroll = document.body.scrollTop || document.documentElement.scrollTop;
    if (winScroll > 20) {
        $('#header').addClass('scrolled');
    } else {
        $('#header').removeClass('scrolled');
    }
    donat_animate();

    $(".open-mega-menu").on("click", function () {
        $(".mega-menu-wrap--products").slideDown("fast");
    });

    $(".mega-menu__close").on("click", function () {
        $(".mega-menu-wrap--products").slideUp("fast");
    });

    if ($(".gform_wrapper").length) {
        setTimeout(function () {
            $(".gform_wrapper .ginput_container input").each(function () {
                if ($(this).val() !== '') {
                    $(this).closest(".gfield ").addClass("focused");
                }
            })
        }, 200);
        $(document).on('focus', '.gform_wrapper .ginput_container input, .gform_wrapper .ginput_container textarea', function () {
            $(this).closest(".gfield ").addClass("focused");
        });

        $(document).on('blur', '.gform_wrapper .ginput_container input, .gform_wrapper .ginput_container textarea', function () {
            if ($(this).val() == '') {
                $(this).closest(".gfield ").removeClass("focused");
            }
        });
    }

    $('.wp-block-yoast-faq-block').find('.schema-faq-section').click(function(){
        if ($(this).hasClass( "active" )) {
            $('.schema-faq-section').removeClass("active");
            $(this).find(".schema-faq-answer").slideUp('fast');
        }
        else {
            $('.schema-faq-section').removeClass("active");
            $('.schema-faq-answer').slideUp('fast');
            $(this).addClass("active");
            $(this).find(".schema-faq-answer").slideToggle('fast');
        }
    });

    /* Prefill floating nav with H2 headlines ===========================*/
    prefillFloatingNavigation();
});

$(window).on('scroll', function () {
    winScroll = document.body.scrollTop || document.documentElement.scrollTop;
    if (winScroll > 20) {
        $('#header').addClass('scrolled');
    } else {
        $('#header').removeClass('scrolled');
    }

    didAnimate = true;
});

setInterval(function () {
    if (didAnimate) {
        donat_animate();
        didAnimate = false;
    }
}, 150);

function donat_animate() {
    const element = $('.animate-elements:not(.animate)');
    if (element.length) {
        element.each(function () {
            if ($(this).isInViewport()) {
                $(this).addClass('animate');
            }
        });
    }
}

function prefillFloatingNavigation() {
    let i = 1;
    const element = $('.blog-content__text > h2');
    if (element.length) {
        element.each(function () {
            const content = $(this).text();
            $(this).attr('id', 'blog-headline-h2-' + i);
            $(".article-nav").append("<div class='content-headline has-description-font-size' data-scroll='headline-h2-" + i + "'><a href='#blog-headline-h2-" + i + "'>" + content + "</a></div>");
            i++;
        });
    } else {
        $('.article-nav').hide();
    }
}

$.fn.isInViewport = function () {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};